import { Component, ElementRef, OnInit } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { CommonModule } from "@angular/common";

import { BookletService } from "../services/booklet.service";
import { UmbracoLinkComponent } from "../../../common-components/umbraco-link/umbraco-link.component";
import { ExternalConfigurationService } from "../../../shared-library/services/configuration/external-configuration.service";
import { BookletPageModel } from "./booklet-page.model";
import { BookletItemComponent } from "./booklet-item/booklet-item.component";

@Component({
    selector: BookletPageComponent.SELECTOR,
    templateUrl: "booklet-page.component.html",
    standalone: true,
    imports: [
        CommonModule,
        UmbracoLinkComponent,
        BookletItemComponent
    ]
})
export class BookletPageComponent implements OnInit {
    public static SELECTOR: string = "pcg-ng-booklet-page-component";

    protected pageModel$: Observable<BookletPageModel>;
    protected showDetails$: BehaviorSubject<{ showDetails: boolean }>;

    public constructor(
        private http: HttpClient,
        private configurationService: ExternalConfigurationService<{ path: string }>,
        private domElement: ElementRef,
        protected bookletService: BookletService
    ) {
    }

    public ngOnInit(): void {
        this.configurationService.initialize(this.domElement);
        this.pageModel$ = this.http.get<BookletPageModel>("/umbraco/delivery/api/v2/content/item" + (this.configurationService.config?.path ?? window.location.pathname));
        this.showDetails$ = new BehaviorSubject({ showDetails: false });
    }

    protected toggleDetailedView(): void {
        const currentValue = this.showDetails$.value;
        this.showDetails$.next({showDetails: !currentValue.showDetails});
    }

    public backButtonClicked(e: Event): void {
        e.preventDefault();

        window.history.back();
    }
}
